import { createFileRoute } from '@tanstack/react-router'

const SouvenirPage = () => (
  <main className='min-h-screen bg-emerald-50 px-4 py-8'>
    <h1 className='text-2xl font-bold text-emerald-950'>Quà lưu niệm</h1>
    <p className='mt-2 text-sm text-emerald-900/70'>
      Tính năng đang được chuẩn bị.
    </p>
  </main>
)

export const Route = createFileRoute('/phong-nha/qua-luu-niem/')({
  component: SouvenirPage,
})

